import React, { useState, useEffect } from "react";
import LeadsOverviewChart from "../widgetsCharts/LeadsOverviewChart";
import LatestLeads from "../widgetsTables/LatestLeads";
import Schedule from "../widgetsList/Schedule";
import Project from "../widgetsList/Project";
import { useNavigate, useLocation } from "react-router-dom";
import TeamProgress from "../widgetsList/Progress";
import PaymentRecordChart from "../widgetsCharts/PaymentRecordChart";
import SiteOverviewStatistics from "../widgetsStatistics/SiteOverviewStatistics";
import TasksOverviewChart from "../widgetsCharts/TasksOverviewChart";
import SalesMiscellaneous from "../widgetsMiscellaneous/SalesMiscellaneous";
import PageHeaderDate from "../shared/pageHeader/PageHeaderDate";
import PageHeader from "../shared/pageHeader/PageHeader";
import Footer from "../shared/Footer";
import { leadsOverviewChartOptions } from "../../utils/chartsLogic/leadsOverviewChartOptions";
import { projectsDataTwo } from "../../utils/fackData/projectsDataTwo";
import NavigationMenu from "../shared/navigationMenu/NavigationMenu";
import Header from "../shared/header/Header";
import { fetchFormData } from "../../utils/options";
import Swal from "sweetalert2";
import { format, startOfMonth, endOfMonth } from "date-fns";

const Home = () => {
  const [leadSummary, setLeadSummary] = useState([]);
  const [overviewInfo, setOverviewInfo] = useState([]);
  const [chartOptions, setChartOptions] = useState({});
  const [leads, setLeads] = useState([]);
  const [permission, setPermission] = useState({});
  const [followup, setFollowup] = useState([]);
  const [inquiry, SetInquiry] = useState([])
  const [dateRange, setDateRange] = useState({
    from_date: format(startOfMonth(new Date()), "yyyy-MM-dd"),
    to_date: format(endOfMonth(new Date()), "yyyy-MM-dd"),
  });
  const navigate = useNavigate();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const M_id = queryParams.get("id");

  useEffect(() => {
    window.scrollTo(0, 0);
    if (localStorage.getItem("access_token") === null) {
      navigate("/");
    }
  }, []);

  useEffect(() => {
    const getPermission = async () => {
      const roleId = localStorage.getItem("roleId");
      const M_id = queryParams.get("id");

      const formData = new FormData();
      formData.append("role_id", roleId);
      formData.append("module_id", M_id || 1);

      try {
        const result = await fetchFormData("get-permission", formData, "POST");
        const perm = result?.data;

        setPermission(perm);
      } catch (error) {
        console.error("Error fetching permission", error);
      }
    };

    getPermission();
  }, [M_id]);

  const fetchAllData = async ({ from_date, to_date } = {}) => {
    const userId = localStorage.getItem("id");
    const roleId = localStorage.getItem("roleId");

    const formData = new FormData();
    formData.append("userId", userId);
    formData.append("from_date", from_date || dateRange.from_date);
    formData.append("to_date", to_date || dateRange.to_date);

    try {
      const dashboardData = await fetchFormData(
        "dashboard-leads",
        formData,
        "POST"
      );
      // Dashboard data handling
      if (dashboardData?.code === 200) {

        const summary = dashboardData?.data?.lead_summary || [];
        const data = dashboardData?.data;
        const { latest_lead = [] } = data;
        const { upcoming_followups = [] } = data;

        setFollowup(upcoming_followups);
        setLeads(latest_lead);
        setLeadSummary(summary);
        setOverviewInfo(data.summary_counts);
        setChartOptions(leadsOverviewChartOptions(summary));
        SetInquiry(data.inquiry_summary)
      }
    } catch (error) {
      console.error("Failed to fetch dashboard or permissions:", error);
    }
  };
  const onApplyDateRange = ({ from_date, to_date }) => {
    setDateRange({ from_date, to_date });
    fetchAllData({ from_date, to_date });
  };
  useEffect(() => {
    fetchAllData(dateRange);
  }, []);

  return (
    <>
      <Header />
      <NavigationMenu />
      <main className="nxl-container">
        <div className="nxl-content">
          <PageHeader>
            <PageHeaderDate onApplyDateRange={onApplyDateRange} />
          </PageHeader>
          <div className="main-content">
            <div className="row">
              <SiteOverviewStatistics
                leadSummary={leadSummary}
                inquiry={inquiry}
                permission={permission}
                fromDate={dateRange.from_date}
                toDate={dateRange.to_date}
              />
              <TasksOverviewChart
                overviewInfo={overviewInfo}
                permission={permission}
              />
              <LeadsOverviewChart
                chartHeight={315}
                chartOptions={chartOptions}
                leadSummary={leadSummary}
                permission={permission}
              />
              <LatestLeads leads={leads} permission={permission} />
              <Schedule followup={followup} permission={permission} />
            </div>
          </div>
          <Footer />
        </div>
      </main>
    </>
  );
};

export default Home;
